import { MapPin } from "lucide-react";
import RangePill from "./shared/RangePill.jsx";

export default function LoginRangePanel({ officeCenter, rangeCounts, NEAR_KM, CLOSE_KM, MOD_KM }) {
  if (
    !officeCenter ||
    !Number.isFinite(officeCenter.lat) ||
    !Number.isFinite(officeCenter.lng)
  ) return null;

  return (
    <div className="rounded-2xl border border-gray-200 bg-white p-4 dark:border-white/10 dark:bg-navy-800">
      <div className="mb-2 flex items-center gap-2 text-sm font-semibold dark:text-white">
        <MapPin className="h-4 w-4" /> Login Range from office
        <span className="ml-2 text-xs font-normal text-gray-500">
          Office @ {officeCenter.lat.toFixed(4)}, {officeCenter.lng.toFixed(4)}
        </span>
      </div>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-4">
        <RangePill label="In Office" count={rangeCounts.inOffice} tone="amber" hint={`≤ ${NEAR_KM} km`} />
        <RangePill label="Nearby"    count={rangeCounts.nearby}   tone="blue"  hint={`≤ ${CLOSE_KM} km`} />
        <RangePill label="Moderate"  count={rangeCounts.moderate} tone="amber" hint={`≤ ${MOD_KM} km`} />
        <RangePill label="Far"       count={rangeCounts.far}      tone="blue"  hint={`> ${MOD_KM} km`} />
      </div>

      <div className="mt-2 text-xs text-gray-500">
        Tracking {rangeCounts.total} active GPS devices.
      </div>
    </div>
  );
}
